<template>
  <div class="siteblocks">
    <hero-panel />
    <div class="theme-garden-wrapper">
      <div class="garden-header"><span class="title">Browse Templates</span></div>
      <div v-if="loading" class="loading-spinner">
        <div class="spinner"></div>
      </div>
      <div v-else class="theme-garden">
        <theme-garden-item
            v-for="item in themes"
            v-bind="item"
            :key="item.id"
            :item="item"
            view="siteblocks"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MarketingBlock from 'components/marketing-block';
import PanelBlock from 'components/panel-block';
import style from 'styles/siteblocks.scss';
import { PANELS } from 'app-constants';
import ThemeGardenItem from 'components/sitebuilder/theme-item';
import axios from 'axios';
import HeroPanel from "../../components/sitebuilder/templates/hero-panel.vue";

export default {
  name: 'siteblocks',
  components: {
    'hero-panel': HeroPanel,
    'marketing-block': MarketingBlock,
    'panel-block': PanelBlock,
    'theme-garden-item': ThemeGardenItem,
  },
  data() {
    const welcomePanel = PANELS.SITEBUILDER_TEMPLATES.filter((panel) => panel.name === 'HERO');
    // const themeJson = require(`assets/data/sitebuilder/templates/themes.json`);
    return {
      themes: [],
      enablePromo: false,
      panels: PANELS.SITEBUILDER_TEMPLATES,
      loading: true,
      welcomePanel,
      // themeJson,
    };
  },
  created() {
    this.getThemes(); // Call the method to fetch themes when the component is created
  },
  methods: {
    async getThemes() {
      try {
        // const api_url = '//assets.bravenet.com/siteblocks/themes.json';
        const api_root = process.env.NODE_ENV == 'production'
            ? '//assets.bravenet.com/braveuistatic/json'
            : '/braveuistatic/json';
        const api_url = `${api_root}/themes.json`;
        const response = await axios.get(api_url);
        this.themes = await response.data;
        // this.themes = this.themeJson;
        this.loading = false; // Set loading to false after data is fetched
      } catch (error) {
        console.error('Error fetching themes:', error);
      }
    },
  },
  async mounted() {
    //   let res = await axios.get('https://api-v2.bravenet.com/domains/onsale')
    //   this.loading = false
  },
};
</script>

<style scoped>
.marketing-block {
  border-bottom-style: none;
  min-height:400px;
  .panel {
    display: flex;
    align-items: center;
  }
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.md-progress-spinner {
  .md-progress-spinner-circle {
    stroke: #fff !important;
    color: #fff !important;
  }
}

.garden-header {
  //display: flex;
  display:none;
  flex-wrap: wrap;
  width: 95vw;
  max-width: 1600px;
  margin: auto;
  justify-content: space-between;
  .title {
    font-size: 32px;
  }
}


/* Add styling for the loading spinner */
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px; /* Adjust the height as needed */
}

.spinner {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  position: relative;
  border: 5px solid transparent;
  border-top-color: #42B983FF; /* Initial color */
  animation: spin 4s linear infinite, changeColor 8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes changeColor {
  0% {
    border-top-color: #42B983FF; /* Initial color */
  }
  50% {
    border-top-color: #0074D9FF; /* Transition to this color */
  }
  100% {
    border-top-color: #42B983FF; /* Transition back to the initial color */
  }
}
</style>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/views/sitebuilder/templates.vue